const YOUTUBE_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'music.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com'
]);

const YOUTUBE_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

export const normalizarUrlVideo = (urlVideo, origin = window.location.origin) => {
  const valor = String(urlVideo || '').trim();

  if (!valor) {
    return { tipo: 'vazio', url: '' };
  }

  let url;
  try {
    url = new URL(valor);
  } catch {
    return { tipo: 'invalido', mensagem: 'Informe uma URL de vídeo válida.' };
  }

  if (!['http:', 'https:'].includes(url.protocol)) {
    return { tipo: 'invalido', mensagem: 'A URL do vídeo deve usar HTTP ou HTTPS.' };
  }

  const host = url.hostname.toLowerCase();
  let videoId = null;

  if (host === 'youtu.be' || host === 'www.youtu.be') {
    videoId = url.pathname.split('/').filter(Boolean)[0];
  } else if (YOUTUBE_HOSTS.has(host)) {
    const partes = url.pathname.split('/').filter(Boolean);
    if (url.pathname === '/watch') {
      videoId = url.searchParams.get('v');
    } else if (['embed', 'shorts', 'live'].includes(partes[0])) {
      videoId = partes[1];
    }
  }

  if (YOUTUBE_HOSTS.has(host) || host === 'youtu.be' || host === 'www.youtu.be') {
    if (!videoId || !YOUTUBE_ID_PATTERN.test(videoId)) {
      return { tipo: 'invalido', mensagem: 'Não foi possível identificar o vídeo do YouTube na URL informada.' };
    }

    const embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
    embedUrl.searchParams.set('enablejsapi', '1');
    embedUrl.searchParams.set('origin', origin);
    embedUrl.searchParams.set('playsinline', '1');
    embedUrl.searchParams.set('rel', '0');

    return {
      tipo: 'youtube',
      url: embedUrl.toString(),
      urlOriginal: url.toString()
    };
  }

  return { tipo: 'arquivo', url: url.toString() };
};
